import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LogtoProvider } from '@logto/react';
import './index.css';
import App from './App';
import Callback from './Callback';
import AdminDashboard from './pages/AdminDashboard';
import SuperAdmin from './pages/SuperAdmin';
import UserManual from './pages/UserManual';
import MyHistory from './pages/MyHistory';
import { logtoConfig } from './logtoConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LogtoProvider config={logtoConfig}>
      <BrowserRouter>
        <Routes>
          <Route path="/callback" element={<Callback />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/superadmin" element={<SuperAdmin />} />
          <Route path="/manual" element={<UserManual />} />
          <Route path="/history" element={<MyHistory />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </LogtoProvider>
  </React.StrictMode>
);